import { render } from "./apiPart.vue?vue&type=template&id=254c3acd&scoped=true"
import script from "./apiPart.vue?vue&type=script&lang=js"
export * from "./apiPart.vue?vue&type=script&lang=js"

import "./apiPart.vue?vue&type=style&index=0&id=254c3acd&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254c3acd"]])

export default __exports__